import { createAction } from 'redux-act';
import { createAsyncAction } from "./utils";
export var sendSmsVerification = createAsyncAction('sendSmsVerification', function (mobileNumber) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    meta: {
      mobileNumber: mobileNumber,
      showMessages: showMessages
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.sendSmsVerification(mobileNumber);
    }
  };
});
export var sendSmsReverification = createAsyncAction('sendSmsReverification', function (mobileNumber) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    meta: {
      mobileNumber: mobileNumber,
      showMessages: showMessages
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.sendSmsReverification(mobileNumber);
    }
  };
});
export var verifySmsCode = createAsyncAction('verifySmsCode', function (code) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.verifySmsCode(code);
    }
  };
});
export var jumpToVerifyStep = createAction('Jump to verify step');
export var backToMobileStep = createAction('Back to mobile step');